import { useQuery } from 'hooks/useQuery'

import { fetchPostsbyIds } from 'utils/queries'

import { Post } from 'types/post'

import { useDiscoverContent } from './useDiscoverContent'

/**
 * Retrieves the Post for each Trending Workout as specified in the DiscoverContent entry in the DB.
 * @returns a query for an array of posts.
 */
export const useTrendingWorkouts = () => {
  const { data: discoverContent } = useDiscoverContent()

  if (!discoverContent) {
    console.error('No DiscoverContent in the database.')
  }

  const trendingWorkoutIds = discoverContent ? discoverContent.sections[1].tags : []

  const posts = fetchPostsbyIds({ postIds: trendingWorkoutIds })

  return useQuery<Array<Post>>(['posts', ...trendingWorkoutIds], () => posts)
}
